import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { NgZone } from "@angular/core";
import { AppService } from "@suite/app.service";
import { GlobalTablesService } from "@common/services/global-tables-service";
import { MtxDatetimepickerInputEvent, MtxDatetimepickerMode, MtxDatetimepickerType } from '@ng-matero/extensions/datetimepicker';

import moment, { Moment } from 'moment-timezone';
import { EnpsControl } from '../enps-control/enps-control';
import { DateTime } from '../../data-models/complex-types/date-time';
import { MTX_DATETIME_FORMATS } from '@ng-matero/extensions/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

@Component({
    selector: 'time-control',
    templateUrl: './time-control.html',
    styleUrls: ['./time-control.scss'],
    encapsulation: ViewEncapsulation.None,
    //changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-time-control',
    },
    providers: [
        {
            provide: MTX_DATETIME_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'YYYY-MM-DD',
                    monthInput: 'MMMM',
                    yearInput: 'YYYY',
                    timeInput: 'hh:mm A',
                    datetimeInput: 'YYYY-MM-DD HH:mm',
                },
                display: {
                    dateInput: 'YYYY-MM-DD',
                    monthInput: 'MMMM',
                    yearInput: 'YYYY',
                    timeInput: 'hh:mm A',
                    datetimeInput: 'YYYY-MM-DD HH:mm',
                    monthYearLabel: 'YYYY MMMM',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                    popupHeaderDateLabel: 'MMM DD, ddd',
                },
            },
        },
        { provide: DateAdapter, useClass: MomentDateAdapter }
    ],
})
export class TimeControl extends EnpsControl<Moment | string> {


    @Output() timeChange: EventEmitter<string> = new EventEmitter();
    @ViewChild("control") public control: ElementRef;
    @Input("editable") public editable: boolean = true;

    type: MtxDatetimepickerType = 'time';
    mode: MtxDatetimepickerMode = 'portrait';
    touchUi = false;
    twelvehour = true;
    timeInterval = 5;
    timeInput = true;

    constructor(
        public appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        globalTablesService: GlobalTablesService,
        elementRef: ElementRef
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elementRef);
    }


    dateChanged(value: MtxDatetimepickerInputEvent<Date>) {
        this.changed.emit(this.value);
    }
}
